import {useGetClientTypeQuery} from '@/generated/graphql';

type ClientType = 'BTL' | 'ENT';

export const useClientType = (): ClientType | undefined => {
  const {data} = useGetClientTypeQuery();
  return data?.getClient?.clientType;
};
